<template>
  <div>
    <div>
      <div
        style="border: solid 5px; border-radius: 10px; padding: 0px;"
        class="justify-center row items-center q-mx-xs"
      >
        <div
          v-if="!connectionRequested && !connectionEstablished"
          style="position: fixed; align-items: center;"
          class="column"
        >
          <q-icon
            name="check_box"
            color="primary"
            size="xl"
          />
          <span class="text-h6">Ready</span>
        </div>
        <div
          v-else-if="connectionRequested && !connectionEstablished"
          style="position: fixed; align-items: center;"
          class="column"
        >
          <q-icon
            name="pending"
            color="primary"
            size="xl"
          />
          <span class="text-h6">Connecting...</span>
        </div>

        <video
          ref="video"
          width="100%"
          height="100%"
          style="max-height: 80vh; max-width: 80vw;"
          autoplay
        />
      </div>
      <div class="row justify-end q-mx-xs q-my-md">
        <q-btn
          v-if="!connectionEstablished && !connectionRequested"
          label="Request Screen"
          color="primary"
          @click="requestConnection"
        />
        <q-btn
          v-else-if="connectionRequested && !connectionEstablished"
          label="Cancel Request"
          color="warning"
          @click="stopViewing"
        />
        <q-btn
          v-else-if="connectionEstablished"
          label="Disconnect"
          color="negative"
          @click="stopViewing"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ShareScreen',
  props: {
    registerClient: {
      type: Object,
      required: false,
      default: null
    }
  },
  data () {
    return {
      connectionRequested: false,
      connectionEstablished: false
    }
  },
  computed: {
    title () {
      return `Viewing Register Station ${this.registerClient?.registerStation?.name}`
    }
  },
  beforeUnmount () {
    if (this.connectionRequested || this.connectionEstablished) {
      this.$stopViewing()
    }
  },
  methods: {
    show (registerClient) {
      this.registerClient = registerClient
      this.shown = true
    },
    requestConnection () {
      this.connectionRequested = true
      this.$getScreenShare(this.$refs.video, this.registerClient.id, this.stopCallback, this.startCallback)
    },
    stopViewing () {
      this.$stopViewing()
    },
    stopCallback (message = null) {
      this.connectionEstablished = false
      this.connectionRequested = false
      if (message) {
        this.$mh.showErrors([message])
      }
    },
    startCallback () {
      this.connectionEstablished = true
    }
  }
}
</script>
